import { motion } from "framer-motion";
import { Clock, CheckCircle2, Mail, Leaf } from "lucide-react";

const detail = [
  { icon: CheckCircle2, text: "Eight questions" },
  { icon: Clock, text: "Around three minutes" },
  { icon: Leaf, text: "No right or wrong answers" },
  { icon: Mail, text: "Personalised results and our Personal Clarity Prospectus by email" },
];

export default function Landing({ onStart }) {
  return (
    <main data-testid="landing-page">
      <section className="relative overflow-hidden">
        <div
          className="absolute inset-0 -z-10"
          style={{
            background:
              "radial-gradient(60% 55% at 15% 10%, rgba(74,160,164,0.14) 0%, rgba(74,160,164,0) 60%), radial-gradient(50% 50% at 95% 20%, rgba(244,184,71,0.14) 0%, rgba(244,184,71,0) 55%)",
          }}
        />
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-10 pb-10">
          <div className="grid lg:grid-cols-[1.15fr_0.85fr] gap-10 lg:gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <p className="text-base sm:text-lg uppercase tracking-[0.2em] font-bold text-[#4aa0a4] mb-4">
                Your Working Life
              </p>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] text-[#1e292b]">
                What do you want more of in your working life?
              </h1>
              <p className="mt-6 text-lg sm:text-xl leading-relaxed text-[#5a686b] max-w-xl">
                You’ve built experience, skills and a life around your work. What would you like the
                next chapter to give you? Take our short quiz to explore what matters now—more freedom,
                meaning, growth, connection, or balance and energy.
              </p>

              <button
                onClick={onStart}
                data-testid="landing-start-button"
                className="mt-8 inline-flex items-center justify-center bg-[#4aa0a4] text-white text-base font-medium px-7 py-3.5 rounded-full hover:bg-[#3b868a] transition-all shadow-md hover:shadow-lg focus:outline-none focus-visible:ring-4 focus-visible:ring-[#4aa0a4]/30 active:scale-[0.98] weave-focus"
              >
                Explore what I want more of
              </button>

              <p className="mt-6 text-sm leading-relaxed text-[#5a686b] max-w-md italic">
                You don’t need a business idea or a plan to leave your job. Just a little space to think.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="relative"
            >
              <div className="absolute -inset-3 rounded-[28px] bg-[#f4b847]/20 rotate-2" />
              <img
                src="https://images.unsplash.com/photo-1790575169041-35d50a85ba72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="A thoughtful professional reflecting in a warm workspace"
                className="relative rounded-[24px] w-full h-[360px] sm:h-[460px] object-cover shadow-xl"
              />
            </motion.div>
          </div>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <div className="bg-white border border-[#e2ded7] rounded-2xl p-6 sm:p-8 shadow-sm">
          <ul className="grid sm:grid-cols-2 gap-5 sm:gap-6">
            {detail.map(({ icon: Icon, text }, i) => (
              <li key={i} className="flex items-start gap-3" data-testid={`landing-detail-${i}`}>
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#eef6f6]">
                  <Icon className="h-5 w-5 text-[#4aa0a4]" />
                </span>
                <span className="text-base leading-relaxed text-[#1e292b]">{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </main>
  );
}
